import { useMemo } from 'react'

export interface PasswordStrength {
  hasMinLength: boolean
  hasSpecialChar: boolean
  hasNumber: boolean
  hasUpperCase: boolean
  hasLowerCase: boolean
  isValid: boolean
}

export function usePasswordStrength(password: string): PasswordStrength {
  return useMemo(() => {
    const hasMinLength = password.length >= 8
    const hasSpecialChar = /[!@#$%^&*]/.test(password)
    const hasNumber = /\d/.test(password)
    const hasUpperCase = /[A-Z]/.test(password)
    const hasLowerCase = /[a-z]/.test(password)

    const isValid =
      hasMinLength && hasSpecialChar && hasNumber && hasUpperCase && hasLowerCase

    return {
      hasMinLength,
      hasSpecialChar,
      hasNumber,
      hasUpperCase,
      hasLowerCase,
      isValid,
    }
  }, [password])
}
